import { LoginType } from 'react-aad-msal';
import { authPaths } from 'config/route-config';

const {
  VITE_AZURE_AD_CLIENT_ID,
  VITE_AZURE_AD_TENANT_ID,
  VITE_PATH_PREFIX
} = process.env;

const redirectURI = `${window.location.origin}${VITE_PATH_PREFIX}${authPaths.authResponse}`;

export const authConfig = {
  auth: {
    authority: `https://login.microsoftonline.com/${VITE_AZURE_AD_TENANT_ID}`,
    clientId: VITE_AZURE_AD_CLIENT_ID,
    postLogoutRedirectUri: redirectURI,
    redirectUri: redirectURI,
    validateAuthority: true,

    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false
  }
};

export const authParams = {
  scopes: ['User.Read']
};

export const authOptions = {
  loginType: LoginType.Redirect,
  tokenRefreshUri: redirectURI
};
